export const SET_PAGE_ANSWER = '@clientReportModalAnswer/SET_PAGE';
export const SET_ROWS_COUNT_ANSWER = '@clientReportModalAnswer/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE_ANSWER = '@clientReportModalAnswer/SET_ROWS_PER_PAGE';
export const SET_ORDER_ANSWER = '@clientReportModalAnswer/SET_ORDER';
export const SET_ORDERBY_ANSWER = '@clientReportModalAnswer/SET_ORDERBY';
